import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FadeInDelay, ZoomInAnimation } from '@sml/utility';

type spinnerType = 'spinner' | 'dots';
type size = 'sm' | 'md' | 'lg'

@Component({
  selector: 'sml-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
  animations: [ZoomInAnimation, FadeInDelay],
  encapsulation: ViewEncapsulation.None,
})
export class SpinnerComponent {
  @Input() type: spinnerType = 'dots';
  @Input() showImage = false;
  @Input() isGlobal = true;
  @Input() size: size = 'lg';
  @Input() loaderClass = '';// For blue dot we will use "dot" class
  @Input() wrapperClass = '';
}
